// extracted by mini-css-extract-plugin
module.exports = {"menu":"SelectMenu_menu__3l5iu","open":"SelectMenu_open__3Xr7H","menuTrigger":"SelectMenu_menuTrigger__1fRDN"};